import React, { useState } from "react";
import "./login.css";
import config from '../../../config/config';
import Swal from 'sweetalert2'; // Import SweetAlert2
import { Route } from "react-router-dom";
import { useNavigate, useParams } from 'react-router-dom';
const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.password.trim()) newErrors.password = 'Password is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData };
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Swal.fire('Validation Error', 'Please correct the highlighted fields.', 'warning');

    }
    else {
      setErrors({});
      const response = await config.login(payload);
      if (response) {
               let res = response.data.user;
            localStorage.setItem('email', res.email);
            localStorage.setItem('userType', res.userType);
            localStorage.setItem('userId', res._id);
        localStorage.setItem('userName', res.name);
        localStorage.setItem('userImage', res.image);
        localStorage.setItem('userType', res.userType);
        localStorage.setItem('userId', res._id);
            setTimeout(() => {
                  navigate('/admin/dashboard');
            }, 1000);
        // Swal.fire({ text: response.data.message || 'Login  successfully!', icon: response.data.icon }).then((result) => {
        //   if (result.isConfirmed) {
        //     console.log("ssss");

        //   }
        // });
      } else {
        Swal.fire({ text: response.data.message || 'Login  Failed!', icon: response.data.icon }).then((result) => {
          if (result.isConfirmed) {
            // navigate(-1);
          }
        });
      }
    }
    // console.log("Login Submitted:", formData);

    // Example API call:
    // config.login(formData).then(...)
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">

        {/* Left Image Section */}
        <div className="image-section">
          <img
            src="/assets/img/login.png"
            alt="Login"
          />
        </div>

        {/* Right Login Form */}
        <div className="form-section">
          <h2 className="title">Welcome Back</h2>
          <p className="subtitle">Login to the Dashboard</p>

          <form onSubmit={handleSubmit} className="login-form">

            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                name="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            {/* <div className="form-group remember-me">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember">Remember me</label>
            </div> */}

            <button type="submit" className="login-btn">LOGIN</button>

          </form>

        </div>
      </div>
    </div>
  );
};

export default Login;
